import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify)
Vue.prototype.$colors = colors

export default new Vuetify({
  breakpoint: {
    mobileBreakpoint: 640
  },
  theme: {
    themes: {
      light: {
        accent: colors.pink.base,
        primary: colors.indigo.base
      },
    },
  }
})
